import { useSignupState } from './useSignupState'
import { useSignupSession } from './useSignupSession'
import { useCallback, useRef } from 'react'

export const useFetchPrinterClaimStatus = () => {
  const { partialSubscription } = useSignupState()
  const { instantInkService } = useSignupSession()
  const startedWaitingTimeRef = useRef<number | null>(null)

  const getTotalWaitingTime = useCallback(
    (startedWaitingTime: number | null) => {
      const getWaitingTime = startedWaitingTime
        ? ((Date.now() - Number(startedWaitingTime)) / 1000).toFixed(2)
        : undefined

      return getWaitingTime ? Number(getWaitingTime) : undefined
    },
    []
  )

  const fetchPrinterClaimStatus = useCallback(async () => {
    if (startedWaitingTimeRef.current === null) {
      startedWaitingTimeRef.current = Date.now()
    }
    try {
      const totalWaitingTime = getTotalWaitingTime(
        startedWaitingTimeRef.current
      )
      const { data } = await instantInkService.fetchPrinterClaimStatus(
        partialSubscription?.data?.id,
        totalWaitingTime
      )

      return data
    } catch (error) {
      throw {
        error: error
      }
    }
  }, [instantInkService, partialSubscription?.data?.id, getTotalWaitingTime])

  return {
    fetchPrinterClaimStatus
  }
}
